@if (label()) {
  <label [for]="inputId" class="form-label">
    {{ label() }}
    @if (required()) {
      <span class="text-danger ml-0.5">*</span>
    }
  </label>
}

@if (type() === 'multiline') {
  <textarea
    [id]="inputId"
    class="form-textarea"
    [class.has-error]="hasError()"
    [disabled]="computedDisabled()"
    [value]="currentValue()"
    [placeholder]="placeholder() ?? ''"
    [attr.aria-describedby]="helpText() || getErrorMessage() ? inputId + '-help' : null"
    (input)="onInput($event)"
    (blur)="onBlur()">
  </textarea>
} @else {
  <div class="relative">
    <input
      [id]="inputId"
      class="form-input"
      [class.has-error]="hasError()"
      [class.pr-10]="showable()"
      [type]="effectiveType()"
      [disabled]="computedDisabled()"
      [value]="currentValue()"
      [placeholder]="placeholder() ?? ''"
      [attr.aria-describedby]="helpText() || getErrorMessage() ? inputId + '-help' : null"
      (input)="onInput($event)"
      (blur)="onBlur()" />
    @if (showable()) {
      <button
        type="button"
        class="text-text-tertiary hover:text-text-secondary absolute top-1/2 right-2.5 -translate-y-1/2 transition-colors focus:outline-none"
        [attr.aria-label]="showValue() ? 'Hide password' : 'Show password'"
        (click)="showValue.set(!showValue())">
        <i [class]="showValue() ? ICONS.eyeSlash : ICONS.eye" class="text-base"></i>
      </button>
    }
  </div>
}

@if (getErrorMessage(); as msg) {
  <p [id]="inputId + '-help'" class="form-help is-error">{{ msg }}</p>
} @else if (helpText()) {
  <p [id]="inputId + '-help'" class="form-help">{{ helpText() }}</p>
}
